import * as queryString from 'query-string';

const pkceBasePath = '/pkce';

function appLoginUrl(appUriProtocol: string, authorizationCode: string, host:string) {
  return `${appUriProtocol}://pkce/login?authorizationCode=${authorizationCode}&host=${host}`;
}

function generateCodeChallengePath() {
  return `${pkceBasePath}/generateCodeChallenge`;
}

function getAuthorizationCodePath() {
  return `${pkceBasePath}/getAuthorizationCode`;
}

function getAuthorizationCodeUrl(
  openExternal = false,
  params?: { appUriProtocol: string; codeChallenge: string; codeChallengeMethod:string; },
) {
  const flags = openExternal ? { openExternal: true } : null;
  return buildUrl(getAuthorizationCodePath(), flags, params);
}

function loginPath() {
  return `${pkceBasePath}/login`;
}

export const PKCEUrls = {
  appLoginUrl,
  generateCodeChallengePath,
  getAuthorizationCodePath,
  getAuthorizationCodeUrl,
  loginPath,
};

/**
 * Build the URL from the given path and any given extra query params.
 */
function buildUrl(path: string, flags?: Record<string, any>, queryParams?: Record<string, any>) {
  const encodedFlags = flags ? queryString.stringify(flags) : '';
  const existingFlags = window.location.search ? window.location.search.substring(1) : '';
  const combinedFlags = [ existingFlags, encodedFlags ].filter(Boolean)
    .join('&');
  return '/' + (flags ? `?${combinedFlags}` : '')
    + '#' + path
    + (queryParams ? `?${queryString.stringify(queryParams)}` : '');
}
